import { supabase } from '../../common/config/supabase';
import { OrderDirection } from '../../common/enums/order-direction.enum';
import { ICommonRequest } from '../../common/interfaces/common-request.interface';
import { IPaginatedEntity } from '../../common/interfaces/paginated-entity.interface';

export const getCommonRequests = async (
  client_id: string,
  company_id: string,
  limit: number,
  page: number,
  year: string,
  month: string,
  orderBy?: string,
  orderDirection?: OrderDirection,
): Promise<IPaginatedEntity<ICommonRequest>> => {
  const { data, error } = await supabase.rpc('get_common_requests', {
    limit_val: limit,
    page_val: page,
    order_direction: orderDirection,
    order_by: orderBy,
    year_val: year || null,
    month_val: month || null,
    client_id_val: client_id,
    company_id_val: company_id,
  });

  if (error) {
    throw error;
  }

  return {
    items: data,
    meta: {
      currentPage: page,
      itemCount: data.length,
      itemsPerPage: limit,
      totalItems: data[0] ? data[0].total_count : 0,
      totalPages: data[0] ? Math.ceil(+data[0].total_count / limit) : 0,
      orderByColumn: orderBy,
      orderDirection: orderDirection,
    },
  };
};

export const getCommonRequestsYears = async (): Promise<any> => {
  const { data } = await supabase.from('common_months_years').select('year');

  return data?.map((year) => year.year);
};
